/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Input.Touch
 */

/* eslint-disable */
module.exports = {

    TouchManager: require('./TouchManager')
       
};
/* eslint-enable */



//////////////////
// WEBPACK FOOTER
// ./input/touch/index.js
// module id = 792
// module chunks = 0